import React from "react"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function SortedDescendingIcon() {
  return <ArrowDropDownIcon className="icon" />;
}
